// extracted by mini-css-extract-plugin
export default {"image":"p3-z","loaded":"q3-z"};